import React from "react";
import videojs from "video.js";
import "./video-js.css";

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { url, type, onReady, height } = props;

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: false,
    sources: [
      {
        src: url,
        type: type,
      },
    ],
    aspectRatio: "16:9",
  };

  React.useEffect(() => {
    // videojs?.Hls?.xhr?.beforeRequest = function (options) {
    //   console.log("🚀 ~ file: VideoView.jsx:25 ~ React.useEffect ~ options:", options);
    //   options.headers = {
    //     "Access-Control-Allow-Origin": "*",
    //   };
    //   return options;
    // };
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement("video-js");

      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current.appendChild(videoElement);

      const player = (playerRef.current = videojs(
        videoElement,
        videoJsOptions,
        () => {
          videojs.log("player is ready");
          onReady && onReady(player);
        }
      ));

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(videoJsOptions.autoplay);
      player.src(videoJsOptions.sources);
    }
  }, [videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div
      data-vjs-player
      style={{
        width: "100%",
        height: height || "var(--sidebar-width)",
      }}
    >
      <div ref={videoRef} className="vjs-16-9" />
    </div>
  );
};

export default VideoJS;
